module.exports = __webpack_public_path__ + "static/img/guide1.6375c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide1.png
// module id = xgl3
// module chunks = 10